export default class UrlBuilder {
    constructor(conditions = null, sorting = null, pagination = null, url = '') {

        this.url = url;

        this.conditions = conditions;

        if (sorting !== null && sorting.length > 0) {
            this.sorting = sorting;
        }
        
        this.pagination = pagination;

    }

    getUrl() {
        let params = [];

        if (typeof this.conditions === 'object' && this.conditions !== null) {
            if (this.conditions['fields']) {
                //console.debug('conditions.fields',this.conditions.fields)
                this.conditions.fields.forEach((item, key) => {
                    //console.debug('item',item,'key',key)
                    params.push(item.key + '=' + item.value);
                });
            }
        }

        if (this.sorting) {
            for (let i in this.sorting) {
                let item = this.sorting[i];
                if (item.sortOrder) {
                    params.push('sortField[]=' + item.sortField + '&sortOrder[]=' + item.sortOrder);
                }
            }
        }

        if (this.pagination) {
            for (let p in this.pagination) {
                switch (p) {
                    case 'page':
                        params.push(p + '=' + this.pagination[p]);
                        break;
                }
            }
        }

        if (params.length) {
            this.url += '?' + params.join('&')
        }

        return this.url;
    }
}